<template>
  <div :style="'background-color:' + color + ';'">
  </div>
</template>
<script>
export default {
  props: ['color'],
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/BlockWidget.vue